import * as React from 'react'
import Link from '@mui/material/Link'
import { PrismicRichText, PrismicRichTextProps } from '@prismicio/react'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'

const RenderRichText = ({
  field,
  components,
}: {
  field: {
    richText: PrismicRichTextProps['field']
  }
  components?: PrismicRichTextProps['components']
}) => {
  if (components)
    return <PrismicRichText field={field?.richText} components={components} />

  return (
    <PrismicRichText
      field={field?.richText}
      components={{
        heading1: ({ children }) => (
          <Typography variant="h1" gutterBottom>
            {children}
          </Typography>
        ),
        heading2: ({ children }) => (
          <Typography variant="h2" gutterBottom>
            {children}
          </Typography>
        ),
        heading3: ({ children }) => (
          <Typography variant="h3" gutterBottom>
            {children}
          </Typography>
        ),
        heading4: ({ children }) => (
          <Typography variant="h4" gutterBottom>
            {children}
          </Typography>
        ),
        heading5: ({ children }) => (
          <Typography variant="h5" gutterBottom>
            {children}
          </Typography>
        ),
        heading6: ({ children }) => (
          <Typography variant="h6" gutterBottom>
            {children}
          </Typography>
        ),
        paragraph: ({ children }) => (
          <Typography variant="body1" gutterBottom>
            {children}
          </Typography>
        ),
        hyperlink: ({ node, children, text }) => {
          const { url, target } = node.data as {
            url: string,
            target?: string,
          };
          const rel = target ? 'noopener noreferrer' : undefined;
          return (
            <Link href={url} target={target} title={text} rel={rel}>
              {children}
            </Link>
          );
        },
        list: ({ children }) => <List dense>{children}</List>,
        oList: ({ children }) => (
          <Box
            component="ol"
            sx={{
              '& > li': {
                listStyleType: 'decimal',
              },
            }}
          >
            {children}
          </Box>
        ),
        listItem: ({ children }) => (
          <ListItem
            dense
            sx={{
              pl: 0,
            }}
          >
            {children}
          </ListItem>
        ),
      }}
    />
  )
}

export default RenderRichText
